const modalClasses = [
  "w-full",
  "h-full",
  "absolute",
  "z-10",
  "top-0",
  "bottom-0",
  "right-0",
  "left-0",
];

const isValidPostCode = (postCode) => /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} [0-9][A-Z]{2}$/i.test(processPostcode(postCode));


const isValidEmail = (email) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const processPostcode = (postcode) => {
  postcode = postcode.trim();
  postcode = postcode.toUpperCase();
  return postcode;
}

export { modalClasses, isValidPostCode, isValidEmail };
